import { RootState } from 'src/store/store';
import { PlusSubscriptionSliceStateType } from 'src/store/plusSubscription/slice';
import { PlusSubscriptionModalInfoResponseType } from 'src/models/plusSubscription';

export const PlusSubscriptionModalSelector = ({
  plusSubscription,
}: RootState): PlusSubscriptionSliceStateType['modal'] => plusSubscription.modal;

export const PlusSubscriptionPlanSelectionSelector = ({
  plusSubscription: {
    modalInfo: { response },
  },
}: RootState): PlusSubscriptionModalInfoResponseType['PlanSelectionModalInfo'] =>
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  response!.PlanSelectionModalInfo;

export const PlusSubscriptionModalInfoLoadingSelector = ({
  plusSubscription: {
    modalInfo: { loading },
  },
}: RootState): boolean => loading;

export const PlusSubscriptionIsAvailableSelector = ({
  plusSubscription: {
    modalInfo: { response },
  },
}: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
RootState): boolean => response!.IsPlusSubscriptionAvailable;

export const PlusSubscriptionIsFreeTrialAvailableSelector = ({
  plusSubscription: {
    modalInfo: { response },
  },
}: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
RootState): boolean => response!.IsFreeTrialAvailable;

export const PlusSubscriptionPaymentFailedSelector = ({
  plusSubscription: {
    modalInfo: { response },
  },
}: RootState): PlusSubscriptionModalInfoResponseType['FailedPaymentModalInfo'] =>
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  response!.FailedPaymentModalInfo;

export const PlusSubscriptionModalAdditionalParamsSelector = ({
  plusSubscription,
}: RootState): PlusSubscriptionSliceStateType['modal']['additionalParams'] => plusSubscription.modal.additionalParams;

export const PlusSubscriptionPlanPreselectedModalInfoSelector = ({
  plusSubscription: {
    modalInfo: { response },
  },
}: RootState): PlusSubscriptionModalInfoResponseType['PlanPreselectedModalInfo'] =>
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  response!.PlanPreselectedModalInfo;

export const PlusSubscriptionHeaderVisibleSelector = ({
  plusSubscription: {
    modalInfo: { response },
  },
}: RootState): PlusSubscriptionModalInfoResponseType['IsSubscriptionDialogHeaderVisible'] =>
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  response!.IsSubscriptionDialogHeaderVisible;
